import {ResolutionUtils} from '../../infrastructure/utils/resolution-utils';
import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {DeviceViewModel} from "../models/device.view-model";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class DeviceStore extends BaseMobxStore {
  state: DeviceViewModel;

  static injectables = [DeviceViewModel, ResolutionUtils];

  constructor(deviceViewModel: DeviceViewModel, resolutionUtils: ResolutionUtils) {
    super({ name: 'device' }, deviceViewModel);

    resolutionUtils._orientationChangedCallback = (orientation) => this.state.orientation = orientation;
    resolutionUtils._resizeCallback = (width) => {
      this.state._screenSize = width;
    }
  }

  ensureRequiredTypes() {}
}

